import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
import "../css/pagination.css";
import moment from "moment/moment";
import axios from "axios";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { useSelector } from "react-redux";

const PER_PAGE = 25;

const RefundsView = () => {
  const [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state?.auth?.user?.user);
  const [q, setQ] = useState("");

  function searchData() {

    return Data.filter((user) => {
      if (q === "") {
        return user;
      } else if (user?.buyer.fname.toLowerCase().includes(q.toLowerCase())) {
        return user;
      } else return user;
    });
  }
  const fetchRequests = () => {
    let config = {
      method: "post",
      url: Server2 + "/admin/get-refunds",
      data: {
        id: userData._id
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        response.data.sort(
          (b, c) => new Date(c.createdAt) - new Date(b.createdAt)
        );
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {	
    setLoading(true);
    fetchRequests();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  // const splitTwo = (str) => {
  //   return str.split('_').length < 2 ? str : str.split('_')[0] + " " + str.split('_')[1]
  // }

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData = Data.length === 0 ? null : searchData().slice(offset, offset + PER_PAGE).map((refund, index) => (
            <tbody key={index}>
              <tr>
                <td>
                  <div className="d-flex px-2 py-1">
                    <div>
                      <img
                        src={
                          refund.buyer.profile_pic
                            ? refund.buyer.profile_pic
                            : "/img/upload-photo.png"
                        }
                        className="avatar avatar-sm me-2"
                        alt="user1"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                      <h6 className="mb-0 text-sm text-capitalize ">
                        {refund.buyer.fname}
                      </h6>
                      <p className="text-xs text-secondary mb-0">
                        {refund.buyer.email}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                  {refund?.order?.items?.map(product => (
                  <div className="d-flex px-2 py-1">
                    <div>
                      <img
                        src={
                          product.image
                            ? product.image
                            : "/img/upload-photo.png"
                        }
                        className="avatar avatar-sm me-2 rounded-1"
                        alt="user1"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                      <h6 className="mb-0 text-sm text-capitalize ">
                        {product.productName}
                      </h6>
                    </div>
                  </div>
                ))}
                </td>
                <td className="align-middle text-center">
                  <span
                    className={`badge badge-sm bg-gradient-warning`}
                  >
                    Pending
                  </span>
                </td>
                <td className="align-middle text-center">
                  {refund?.amount.toFixed(2)}
                </td>
                <td className="align-middle">
                  <p>
                    {moment(refund.createdAt).format("MMMM Do, YYYY  h:mm A")}
                  </p>
                </td>
                {/* <td className="allign-middle">
                  <div className="d-flex justify-content-center ">
                    <Button style={{ background: '#6148a1', border: 'none' }}>▼</Button>
                  </div>
                </td> */}
              </tr>
            </tbody>
          ));

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="card-header pb-0">
                    <h6>Disputes</h6>
                  </div>
                  <div
                    className="card-body px-0 pt-0 pb-2 task"
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <div className="table-responsive p-0">
                      <table className="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th className="text-uppercase">Buyer</th>
                            <th className="text-uppercase">Product(s)</th>
                            <th className="text-uppercase text-center">Status</th>
                            <th className="text-uppercase text-center">Amount</th>
                            <th className="text-uppercase ps-2">Last Processed</th>
                            {/* <th className="text-uppercase text-center">Actions</th> */}
                          </tr>
                        </thead>
                        {currentPageData}
                      </table>
                    </div>

                    {searchData().length > 24 ? (
                      <div
                        className=" mt-4"
                        style={{
                          padding: 2,
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={
                            <MdOutlineNavigateNext
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={
                            <GrFormPrevious
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default RefundsView;